import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { InsuranceInfoCardComponent } from './insurance-info-card.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
  ],
  declarations: [InsuranceInfoCardComponent],
  exports:[InsuranceInfoCardComponent]
})
export class InsuranceInfoCardModule { }
